import React from 'react';
import { compose } from 'redux';
import { WithTranslation, withTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import UploadMore from '../_partials/UploadMore';
import { BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';
import { PapiUser } from '@wix/da-papi-types';
import withFeatureFlags, {
  WithFeatureFlagsProps,
} from '@wix/da-react-context/pkg/flags/withFeatureFlags';
import { ShopItemType } from '../../../../../types/shop';
import EmptyState from '../_partials/EmptyState';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import ShopGrid from '../ShopGrid';
import s from '../ShopSection.scss';

export interface Props {
  className?: string;
  isOwner: boolean;
  user: PapiUser;
  onOpenChat: (user: PapiUser) => void;
}

const enhance = compose(
  withSectionFetchSpinner,
  withFeatureFlags,
  withTranslation()
);
export class ShopPrints extends React.Component<
  Props & WithFeatureFlagsProps & WithTranslation
> {
  render() {
    const { className, isOwner, flags, t } = this.props;
    const kill_prints_act_one = flags.includes('kill_prints_act_one');

    return (
      <div className={s['section-with-no-header']}>
        <ShopGrid
          className={className}
          itemType={ShopItemType.PRINTS}
          uploadMore={
            kill_prints_act_one ? undefined : (
              <UploadMore
                itemType={ShopItemType.PRINTS}
                onCreate={() =>
                  window.location.assign(`${URLS.ROOT}/me/gallery`)
                }
                biData={BiData<DefaultBiEvent>({
                  evid: 2,
                  click_info: 'create_print',
                  sectionname: 'prints',
                })}
              />
            )
          }
          emptyState={
            <EmptyState
              view="large"
              shopItemType={ShopItemType.PRINTS}
              biData={BiData<DefaultBiEvent>({
                evid: 2,
                click_info: 'create_print',
                sectionname: 'prints',
              })}
              buttonLabel={
                isOwner ? t('pages.shop.emptyState.goToGallery') : undefined
              }
              onButtonClick={
                isOwner
                  ? () => window.location.assign(`${URLS.ROOT}/me/gallery`)
                  : undefined
              }
            />
          }
        />
      </div>
    );
  }
}

export default enhance(ShopPrints) as React.ComponentType<Props>;
